<div class="query-container">
  <div class="page-header">
    <h1 class="page-title"><mat-icon>search</mat-icon> Query</h1>
    <span class="page-subtitle">Advanced search across all return records</span>
  </div>

  <div class="criteria-card mat-elevation-z2">
    <div class="criteria-grid">
      <mat-form-field appearance="outline">
        <mat-label>Customer ID</mat-label>
        <input matInput [(ngModel)]="customerId" placeholder="e.g. TDT-000193" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Period (YYYY-MM)</mat-label>
        <input matInput [(ngModel)]="period" placeholder="2026-06" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Frequency</mat-label>
        <mat-select [(ngModel)]="frequency">
          <mat-option value="">Any</mat-option>
          @for (f of frequencyOptions; track f) {
            <mat-option [value]="f">{{ f | titlecase }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Status</mat-label>
        <mat-select [(ngModel)]="statuses" multiple>
          @for (s of statusOptions; track s) {
            <mat-option [value]="s">{{ s.replace('_', ' ') | titlecase }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Due date from</mat-label>
        <input matInput [matDatepicker]="fromPicker" [(ngModel)]="dueDateFrom" />
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Due date to</mat-label>
        <input matInput [matDatepicker]="toPicker" [(ngModel)]="dueDateTo" />
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Balance due</mat-label>
        <mat-select [(ngModel)]="hasBalanceDue">
          <mat-option value="">Any</mat-option>
          <mat-option value="true">Has balance</mat-option>
          <mat-option value="false">Paid in full</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="criteria-actions">
      <button mat-stroked-button (click)="reset()">Reset</button>
      <button mat-flat-button color="primary" (click)="search()" [disabled]="loading">
        <mat-icon>search</mat-icon> Search
      </button>
    </div>
  </div>

  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if (error) {
    <div class="error-banner">{{ error }}</div>
  }

  @if (searched && !loading) {
    <div class="results-header">
      <span class="results-count">{{ results.length }} result{{ results.length === 1 ? '' : 's' }}</span>
      <button mat-stroked-button (click)="exportCsv()" [disabled]="!results.length">
        <mat-icon>download</mat-icon> Export CSV
      </button>
    </div>

    <div class="mat-elevation-z2 table-container">
      <table mat-table [dataSource]="results" aria-label="Query results">
        <ng-container matColumnDef="accountName">
          <th mat-header-cell *matHeaderCellDef>Account</th>
          <td mat-cell *matCellDef="let r">{{ r.accountName }}</td>
        </ng-container>
        <ng-container matColumnDef="customerId">
          <th mat-header-cell *matHeaderCellDef>Customer ID</th>
          <td mat-cell *matCellDef="let r">{{ r.customerId }}</td>
        </ng-container>
        <ng-container matColumnDef="period">
          <th mat-header-cell *matHeaderCellDef>Period</th>
          <td mat-cell *matCellDef="let r">{{ r.period }}</td>
        </ng-container>
        <ng-container matColumnDef="frequency">
          <th mat-header-cell *matHeaderCellDef>Frequency</th>
          <td mat-cell *matCellDef="let r">{{ r.frequency | titlecase }}</td>
        </ng-container>
        <ng-container matColumnDef="dueDate">
          <th mat-header-cell *matHeaderCellDef>Due date</th>
          <td mat-cell *matCellDef="let r">{{ r.dueDate ? (r.dueDate | date:'MM/dd/yyyy') : '—' }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let r">{{ r.status?.replace('_', ' ') | titlecase }}</td>
        </ng-container>
        <ng-container matColumnDef="totalAmountDue">
          <th mat-header-cell *matHeaderCellDef>Amount due</th>
          <td mat-cell *matCellDef="let r">{{ r.totalAmountDue | currency:'USD':'symbol':'1.2-2' }}</td>
        </ng-container>
        <ng-container matColumnDef="balanceDue">
          <th mat-header-cell *matHeaderCellDef>Balance due</th>
          <td mat-cell *matCellDef="let r">{{ r.balanceDue | currency:'USD':'symbol':'1.2-2' }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
            No returns match the criteria.
          </td>
        </tr>
      </table>
    </div>
  }
</div>
